export interface IBannersEnvelope {
  dataCollection: IBanner[];
  dataCount: number;
}

export interface IBanner{
  id: string;
  code: string;
  url: string;
  redirectUrl: string;
}

export class BannerFormValues {
  id?: string = undefined;
  code: string = "";
  url: string = "";
  redirectUrl: string = "";

  constructor(init?: BannerFormValues) {
    Object.assign(this, init);
  }
}